// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
import { by } from '../../common/routerAccess';

import {
  List
} from './';

import {
  List as ListCategory
} from '../category'

import Home from "../home/Home"

import Presence from "../presence/Presence"

export default {
  path: 'event',
  name: 'Event',
  access: by.ALL,
  childRoutes: [
    { path: 'presence', name: 'Presence', component: Presence, isIndex: true },
    { path: 'list', name: 'List', component: List, isIndex: true },
    { path: ':id', name: 'Item', component: Home },
    { path: ':id/category', name: 'Category', component: ListCategory },
  ],
};



// WEBPACK FOOTER //
// ./src/features/event/route.js